module.exports = __webpack_public_path__ + "img/left-arrow.be24b51.svg";